// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2669":"c132bf7d","5194":"badf541d"}[chunkId] || chunkId) + "." + {"234":"59cc6bb1c7f084e3","552":"81d5ff691a9856d8","2669":"2759133ab0e78900","5194":"fe2f55868cc11743"}[chunkId] + ".js";
};